import { SlotGameType1_21 } from '../SlotGameType1_21';

export class BurningFruits2021 extends SlotGameType1_21
{
}
